import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Components
import Search from '../Search';
import SearchResults from '../Search/SearchResults';
import { SearchModeContext } from '../../../../../algolia-search/js/context/searchContext';
import EventCard from '@molecules/EventCard';
import client from '@general/graphql/client';

// Functionality
import { getTodayUnix } from '@general/dates';
import { SAVED_EVENTS_QUERY } from '@general/graphql/event.graph';
import { mapSearchEventToProps } from '@general/transforms/event.transform';

/**
 * Displays all the functionality of Search Upcoming Events
 *
 * @returns SearchResults Component
 */
const SearchNextEvents = () => {
    const [filters] = useState(`meeting_end_timestamp >= ${getTodayUnix()} AND NOT event_types:"Committee Events"`);

    return (
        <SearchModeContext.Provider value={{}}>
            <Search
                index="events_meeting_start_time_asc"
                filters={filters}
                defaultViewType="card"
                displayPagingToolbar={false}
                displaySearchBox={false}
                displaySearchOptions={false}
                hitsPerPage={3}
                maxWidth="auto"
            >
                <SearchResults
                    cardComponent={EventCard}
                    listItemComponent={EventCard}
                    index="events_meeting_start_time_asc"
                    query={SAVED_EVENTS_QUERY}
                    transformFunc={mapSearchEventToProps}
                    typePlural="viewerEvents"
                    NoResultsText={() => <>There are no Upcoming Events.</>}
                />
            </Search>
        </SearchModeContext.Provider>
    );
};

export default SearchNextEvents;
